import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_2 = ["id"];
const _hoisted_3 = {
  class: "name"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  class: "content-item description"
};
const _hoisted_6 = {
  class: "item-text"
};
const _hoisted_7 = {
  class: "item-content"
};
const _hoisted_8 = {
  key: 0,
  class: "content-item parameters"
};
const _hoisted_9 = {
  class: "item-text"
};
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "circle"
}, null, -1);
const _hoisted_11 = {
  key: 0,
  class: "pre"
};
const _hoisted_12 = {
  key: 1,
  class: "content-item result"
};
const _hoisted_13 = {
  class: "item-text"
};
const _hoisted_14 = {
  class: "item-content"
};
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", {
  class: "circle"
}, null, -1);
const _hoisted_16 = {
  key: 0,
  class: "pre"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ViewContent = _resolveComponent("ViewContent", true);
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.list, (item, index) => {
    return _openBlock(), _createElementBlock(_Fragment, null, [!item.isFolder ? (_openBlock(), _createElementBlock("div", {
      class: "content-view-info",
      key: index,
      id: item.id
    }, [_createElementVNode("p", _hoisted_3, [$props.type == 'Interfaces' ? (_openBlock(), _createElementBlock("span", _hoisted_4, "/")) : _createCommentVNode("", true), _createTextVNode(_toDisplayString(item.name), 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('message.Description')), 1), _createElementVNode("p", _hoisted_7, _toDisplayString(item.description), 1)]), $props.type == 'Interfaces' || $props.type === 'Feature' || $props.type === 'DriverEvent' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('message.Parameters')), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.params, (params, index2) => {
      return _openBlock(), _createElementBlock("p", {
        class: "item-content",
        key: index2
      }, [_hoisted_10, _createElementVNode("span", null, _toDisplayString(params.type) + _toDisplayString(params.dimension != 0 ? '[]' : '') + " " + _toDisplayString(params.name), 1), params.remark ? (_openBlock(), _createElementBlock("span", _hoisted_11, " : " + _toDisplayString(params.remark), 1)) : _createCommentVNode("", true)]);
    }), 128))])) : _createCommentVNode("", true), $props.type == 'Interfaces' || $props.type === 'Feature' ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('message.Result')), 1), _createElementVNode("p", _hoisted_14, [_hoisted_15, _createElementVNode("span", null, _toDisplayString(item.returnType) + _toDisplayString(item.dimension != 0 ? '[]' : ''), 1), item.returenDescription ? (_openBlock(), _createElementBlock("span", _hoisted_16, " : " + _toDisplayString(item.returenDescription), 1)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)], 8, _hoisted_2)) : (_openBlock(), _createBlock(_component_ViewContent, {
      type: $props.type,
      list: item.children,
      key: index
    }, null, 8, ["type", "list"]))], 64);
  }), 256))]);
}